<template>
  <el-dialog title="编辑平台用户信息" :center="true" :visible.sync="editVisible">
    <div class="update-body">
      <el-form
        ref="submitForm"
        :model="submitData"
        :rules="validatorRules"
        label-width="80px"
        class="update-body-form"
      >
        <div class="update-body-div">
          <div class="update-item-view">
            <el-form-item label="用户名" prop="userName" >
              <el-input
                      v-model="submitData.userName"
                      placeholder="请填写-用户名"
                      maxlength="10"
                      show-word-limit>
              </el-input>
            </el-form-item>
          </div>
          <div class="update-item-view">
            <el-form-item label="密码" prop="password" >
              <el-input
                  v-model="submitData.password"
                  placeholder="请填写-密码"
                  maxlength="10"
                  show-word-limit>
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="update-body-div">
          <div class="update-item-view">
            <el-form-item label="用户状态" prop="authStatus" >
              <el-select
                  v-model="submitData.authStatus"
                  :clearable="true"
                  placeholder="请选择用户状态">
                <el-option
                    v-for="item in authStatusOptions"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
    <el-button @click="handleCancel" size="mini">取 消</el-button>
    <el-button type="primary" @click="handleSubmit" size="mini">提 交</el-button>
  </span>
    </el-dialog>
</template>

<script>
import Api from "@/services";
import baseUtils from '@/utils/baseUtils'
export default {
  components: {

  },
  name:"ItemEdit",
  data() {
    return {
      //------------------------------------
      authStatusOptions:this.$commonConstants.authStatusOptions,
      //------------------------------------
      editVisible: false,
      submitData: {
        userName:'',
        password:'',
        authStatus:'',
      },
      validatorRules:{
        userName: [
          { required: true, message: '请规范填写用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请规范填写密码', trigger: 'blur' }
        ],
        authStatus: [
          { required: true, message: '请规范填写用户状态', trigger: 'blur' }
        ],
      }
    };
  },
  methods: {
    //处理展示
    showEdit(data) {
      console.log('data:'+JSON.stringify(data))
      if(data){
        this.submitData = {
            ...data
        }
      }
      this.init();
      this.editVisible = true;
    },
    async setOtherData(){

    },
    //处理初始化
    async init() {
      await this.setOtherData();
      const loading = this.$loading({
        lock: true,
        text: "正在请求。。。",
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      });
      loading.close();
    },
    clearAll(){
      console.log('触发清除所有')
      this.submitData = {
        userName:'',
        password:'',
        authStatus:'',
      }
    },
    handleCancel(){
      this.editVisible = false
      this.clearAll();
    },
    //处理提交
    handleSubmit() {
      this.$refs.submitForm.validate((valid) => {
        const params = {};
        if (valid) {
          Object.assign(params, this.submitData);
          console.log("params", params);
        }else{
          this.$message.error('验证异常');
          return;
        }
        const loading = this.$loading({
          lock: true,
          text: "正在提交...",
        });
        try {
          Api.editPlatformUserItem(params).then((res) => {
            if (res.success) {
              this.editVisible = false;
              this.$emit("handleSuccess");
              this.$message({
                  message: "操作成功!",
                  type: "success",
              });
              this.clearAll()
            } else {
              this.$message.error('服务器异常');
            }
          });
          loading.close();
        } catch (error) {
          this.clearAll()
          loading.close();
          this.$message.error(error.message || error.msg || "服务器异常");
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
  .update-body{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
  .update-body-form{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: center;
    align-items: flex-start;
    .update-body-div{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
      width: auto;
      .update-item-view{

      }
      .upload-item-view{
      .upload-item{

        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ItemEdit.vue?a946718e